<script lang="ts" setup>
    import { inject } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { SegmentAccess } from '../Segments.access';
    import SegmentGroup from './SegmentTypes/SegmentGroup.vue';
    import { setIsNewToFalse, collectIsValid } from './SegmentValidators/utils';
    import Loading from '@shared/components/Loading.vue';
    import { bsAlert } from '@shared/components/bsAlerts';
    import SegmentsAdd from './SegmentsAdd.vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const segmentAccess: SegmentAccess = injectorAccess.injector.get(SegmentAccess);

    const { segmentId } = defineProps<{
        segmentId: string;
    }>();

    const trySubmit = (event: Event) => {
        setIsNewToFalse(segmentAccess.state.segment?.SegmentDefinition);
        const isInvalid = collectIsValid(segmentAccess.state.segment?.SegmentDefinition).includes(false);

        isInvalid &&
            bsAlert({
                type: 'danger',
                title: $Resources.GeneralErrorAlertHeading,
                content: $Resources.GeneralErrorAlertBody,
            });

        if (!isInvalid) segmentAccess.save();
    };
</script>

<template>
    <Loading :show="segmentAccess.state.loading" loadingStyle="progress-bar" :fixed="true"></Loading>

    <form @submit.prevent="trySubmit">
        <div class="form-group d-flex gap-sm flex-wrap">
            <SegmentsAdd @add="(newVal) => segmentAccess.addSegment(newVal)" />

            <span class="m-auto-r"></span>

            <button class="btn btn-primary p-lg-r p-lg-l" type="submit" :disabled="segmentAccess.state.loading">
                {{ $Resources.SaveBtn }}
            </button>
        </div>

        <div class="m-lg-b">
            <SegmentGroup
                v-if="segmentAccess.state.segment && segmentAccess.state.segment.SegmentDefinition?.DragAndDropId"
                :segment="segmentAccess.state.segment"
                :segment-group="segmentAccess.state.segment.SegmentDefinition"
                :root="true"></SegmentGroup>
        </div>
    </form>
</template>

<style scoped lang="less"></style>
